"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cachingConfigurationProvider_1 = require("./cachingConfigurationProvider");
exports.CachingConfigurationProvider = cachingConfigurationProvider_1.default;
var spListConfigurationProvider_1 = require("./spListConfigurationProvider");
exports.SPListConfigurationProvider = spListConfigurationProvider_1.default;



//////////////////
// WEBPACK FOOTER
// ./~/sp-pnp-js/lib/configuration/providers/index.js
// module id = 51
// module chunks = 0